<template>
  <div>
    <label class="story-city-input-label d-flex align-center">
      <img
        class="story-city-label-icon"
        :src="require('@/assets/icons/age.svg')"
        alt=""
      />
      <div>{{ $t("story.ageRating") }}</div>
    </label>
    <StoryCityAutocomplete
      v-model="ageRating"
      :items="ageRatings"
      :label="$t('story.basicInfoForm.selectAnAgeRating')"
      item-text="_id"
      item-value="id"
    />
  </div>
</template>
<script>
import gql from "graphql-tag";
import StoryCityAutocomplete from "@/components/Reusable/StoryCityAutocomplete.vue";
export default {
  props: {
    value: String,
  },
  data() {
    return {
      ageRating: this.value,
    };
  },
  watch: {
    ageRating(newValue) {
      this.$emit("input", newValue);
      if (this.ageRatings) {
        this.$emit(
          "ageRatingObject",
          this.ageRatings.filter((ageRating) => ageRating.id == newValue)[0]
        );
      }
    },
    value(newValue) {
      if (this.ageRating != newValue) {
        this.ageRating = newValue;
      }
    },
  },
  apollo: {
    ageRatings: {
      query: gql`
        query {
          storyAgeRatings(order: { orderNumber: "ASC" }) {
            _id
            id
          }
        }
      `,
      update(data) {
        return data.storyAgeRatings;
      },
    },
  },
  components: { StoryCityAutocomplete },
};
</script>
